/**
 * Created by Jerker Nord on 2023-03-20.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {LonerStatics} from "../LonerStatics";
import {LonerContainer} from "../components/LonerContainer";
import {LonerWinLineContainer} from "../components/LonerWinLineContainer";

export class LonerWinLineTopView extends PIXI.Container implements StageLayer {

    private _winLineContainerPool:LonerWinLineContainer[];
    private _winSymbolsContainer:PIXI.Container;
    private _pinsAndThreadsContainer:PIXI.Container;

    constructor() {
        super();
        this.name = "LonerWinLineTopView";

        this.init();
    }

    private init():void {
        this._winSymbolsContainer = new PIXI.Container();
        this._winSymbolsContainer.position.y = (LonerStatics.symbolHeight / 2) - 5;
        this._winSymbolsContainer.position.x = (LonerStatics.symbolWidth / 2) + 2;
        this.addChild(this._winSymbolsContainer);

        this._pinsAndThreadsContainer = new PIXI.Container();
        this._pinsAndThreadsContainer.position.y = (LonerStatics.symbolHeight / 2) - 5;
        this._pinsAndThreadsContainer.position.x = (LonerStatics.symbolWidth / 2) + 2;
        this.addChild(this._pinsAndThreadsContainer);

        this._winLineContainerPool = [];
        let container:LonerWinLineContainer;
        for(let i:number = 0; i < 10; i++) {
            container = this.createContainer();
            this._winSymbolsContainer.addChild(container);
            this._winLineContainerPool.push(container);
        }
    }

    private createContainer():LonerWinLineContainer {
        return new LonerWinLineContainer();
    }

    public getContainer():LonerWinLineContainer {
        for(let i:number = 0; i < this._winLineContainerPool.length; i++) {
            if(this._winLineContainerPool[i].isUsed == false) {
                this._winLineContainerPool[i].isUsed = true;
                this._winLineContainerPool[i].visible = true;
                this._winLineContainerPool[i].alpha = 1;
                this._pinsAndThreadsContainer.addChild(this._winLineContainerPool[i].pinAndThreadContainer);
                return this._winLineContainerPool[i];
            }
        }
        this._winLineContainerPool.push(this.createContainer());
        return this.getContainer();
    }
}